import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {ActionsService} from "../../../Redux/Actions/actions.service";
import {Overlay} from "@angular/cdk/overlay";
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";
import {ApplicationProjectTypeActions} from "../../../Redux/Actions/application-project-types-actions";

@Component({
  selector: 'edsng-confirm-download-dlg',
  templateUrl: './confirm-download-dlg.component.html',
  styleUrls: ['./confirm-download-dlg.component.css']
})
export class ConfirmDownloadDlgComponent implements OnInit{

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<ConfirmDownloadDlgComponent>, private act: ActionsService, private http: HttpClient) {}

  ngOnInit() {
  }

  download(filename) {
    this.getFileUrl(filename).subscribe(presigned_url => {
      const element = document.createElement('a');
      element.setAttribute('href', presigned_url);
      element.setAttribute('download', filename + '.zip');

      element.style.display = 'none';
      document.body.appendChild(element);

      element.click();
      document.body.removeChild(element);
    })

  }

  closeDlg(): void {
    this.dialogRef.close();
  }

  private getFileUrl(filename): Observable<any> {
    const result =  this.http.get('https://yersi4ic77ethhl5mlvtpqcd440cqots.lambda-url.eu-west-1.on.aws/?key='+ filename + '.zip', {responseType: 'json'});
    return result.pipe(map(url => (url as any).presigned_url));;
  }

}
